import { registry } from '@cian/mf-registry/browser';

export async function ensureHeaderMicrofrontend() {
  const apiRuntime = registry().microfrontendStrict('header-frontend').api();

  if (!apiRuntime) {
    throw new Error('Header microfrontend API runtime is unavailable');
  }

  return apiRuntime.ensure();
}
